import { createModel } from '@rematch/core'
import { api } from '@/api'
import { ENContactApiUpdateENContactRequest, ENContactDto } from '@/api/generated'
import type { RootModel } from '.'

type ContactState = {
  contacts?: ENContactDto
}

export const encontact = createModel<RootModel>()({
  state: {} as ContactState,
  reducers: {
    setContacts(state, payload: ENContactDto) {
      state.contacts = payload
    }
  },
  effects: dispatch => {
    const { encontact } = dispatch

    return {
      async getContact(): Promise<void> {
        const { data } = await api.encontact.getENContact()

        encontact.setContacts(data)
      },

      async updateContact({ eNContactDto }: ENContactApiUpdateENContactRequest): Promise<void> {
        await api.encontact.updateENContact({ eNContactDto })
      }
    }
  }
})
